import React, { Component, Fragment } from 'react';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, Input, Button, Table, Form, FormGroup, Alert } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { aggregate, sort_by, CustomListSelect,
         add_perc_key } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { MultBarPlot } from './PlotComponent';
import { postRequest } from '../redux/ActionCreators';

// import { Auth } from 'aws-amplify';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    client_portfolio: state.client_portfolio,
    client_port_metrics: state.client_port_metrics,
    client_port_exposure: state.client_port_exposure,
    client_params: state.client_params,
    client_trades: state.client_trades,
    client_port_metrics_trades: state.client_port_metrics_trades,
    client_port_exposure_trades: state.client_port_exposure_trades
  };
};

class ClientPortAdjust extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_portfolio:false,
        port_id:'Portafolio',
        show_fx:true,
        msg:null,
        risk_dev:0,
        show_perc:false,
        fund_sel:null
      };
      this.header = this.header.bind(this);
      this.addTrade = this.addTrade.bind(this);
      this.addTrade = this.addTrade.bind(this);
      this.resetTrades = this.resetTrades.bind(this);
      this.sendTrades = this.sendTrades.bind(this);
  }
  
    addTrade = async (e) => {
      e.preventDefault();
      const form = e.target;
      if (this.state.fund_sel=='' || this.state.fund_sel==null){
        this.setState({msg:"Seleccionar fondo!"});
      } else if (form.mkt_value.value=='' || form.mkt_value.value==null){
        this.setState({msg:"Valor de mercado inválido!"});
      } else {
        this.props.changeModel('client_trades', 
          [{isin:"",
            assetName:this.state.fund_sel, 
            mktValue:parseFloat(form.mkt_value.value.replace(/,/g, ''))*(form.type.value=='SELL' ? -1:1),
            type:form.type.value},
          ...this.props.client_trades]);
        this.setState({msg:null});
      }
    };
  resetTrades(){
    this.props.changeModel('client_trades', []);
  }

  async sendTrades(){
    if (this.props.client_trades.length==0) {
      this.setState({msg:"No se han insertado operaciones."});
    } else {
      this.setState({msg:null});
      this.setState({loading_portfolio:true});
      try {
        const client_port_exp = await postRequest(
          {
            port:aggregate([...this.props.client_trades, ...this.props.client_portfolio.port], ["isin", 'assetName'], ['mktValue']).map(item=>{
              return {isin:item.isin, name:item.assetName, value:item.mktValue};
            }),
            use_assets_bench:this.props.client_params.assets_bench
          }, 'port_exposure_wm');
        await this.props.changeModel('client_port_exposure_trades', client_port_exp.w_ac);
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          msg_exp: error.message
        });
      }

      try {
        const client_port_metrics = await postRequest(
          { 
            port:aggregate([...this.props.client_trades, ...this.props.client_portfolio.port], ['assetName'], ['mktValue']).map(item=>{
              return {name:item.assetName, value:item.mktValue};
            }), 
            ref_curr:this.props.client_params.fx,
            ini_date:this.props.client_params.date,
            use_assets_bench:this.props.client_params.assets_bench
          }, 'port_metrics_wm');
        console.log(client_port_metrics);
        await this.props.changeModel('client_port_metrics_trades', client_port_metrics.rets_summ);
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          msg: error.message
        });
      }
      this.setState({
        loading_portfolio:false,
      });

    }
  }

  header(){
    return(
      <>
        <div className="row mt-5 justify-content-center">
          <div className="col-auto">
            <h4>Análisis de Portafolio</h4>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className="col-auto">
            <Breadcrumb>
              <BreadcrumbItem><Link to='/client_portfolio/stage/check'>Chequeo del Portafolio</Link></BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/metrics'>Evaluación de Riesgo</Link></BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/suitability'>Alineación de Estrategia de Inversión</Link></BreadcrumbItem>
              <BreadcrumbItem active>Ajuste de Portafolio</BreadcrumbItem>
            </Breadcrumb>
          </div>
        </div>
      </>
      );
  }
  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else if (this.state.loading_portfolio){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                <CustomLoading msg="calculando métricas" icon="fa-calculator" />
              </div>
            </div>
          );
      } else if (this.props.client_portfolio==null){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                <p>No hay datos disponibles.</p>
              </div>
            </div>
          );
      } else {
        const port_saa_adjust = this.props.client_trades.length==0 ? null :
          add_perc_key(aggregate([...this.props.client_trades, ...this.props.client_portfolio.port], ["isin", 'assetName'], ['mktValue']), 'mktValue');
        const port_saa = port_saa_adjust==null 
          ? this.props.client_portfolio.port.map(item=>{
            return {assetName:item.assetName, Portafolio:item[this.state.show_perc ? 'weight' : 'mktValue']};
          }).sort(sort_by('Portafolio', "desc"))
          : port_saa_adjust.map(item=>{
            return {assetName:item.assetName, Portafolio:this.props.client_portfolio.port.filter(port=>port.assetName==item.assetName).length==0 ? 0 :this.props.client_portfolio.port.filter(port=>port.assetName==item.assetName)[0][this.state.show_perc ? 'weight' : 'mktValue'], 
            Ajustado:item[this.state.show_perc ? 'percentage':'mktValue']};
          });
        const port_dev = port_saa_adjust==null 
          ? null
          : port_saa_adjust.map(item=>{
            return {assetName:item.assetName, Delta:Math.round((item[this.state.show_perc ? 'percentage':'mktValue'] - (this.props.client_portfolio.port.filter(port=>port.assetName==item.assetName).length==0 ? 0 : this.props.client_portfolio.port.filter(port=>port.assetName==item.assetName)[0][this.state.show_perc ? 'weight':'mktValue']))*10)/10};
          }).filter(k=>Math.abs(k.Delta)>0.00001).sort(sort_by('Delta'));

        const unique_ac_vals = this.props.client_port_exposure_trades!==null ? Array.from(
            new Set(this.props.client_port_exposure_trades.map(k=>[k.AssetClass, k.Currency]).concat(this.props.client_port_exposure.w_ac.map(k=>[k.AssetClass, k.Currency])).map(JSON.stringify)), // convert each array to string
            JSON.parse // convert back to array
          ) : null;
        const ac_compar = this.props.client_port_exposure_trades!==null ? unique_ac_vals.map(item=>{
          return {AssetClass:item[0] + " | " + item[1], 
                  Portafolio:this.props.client_port_exposure.w_ac.find(k=>k.AssetClass==item[0] && k.Currency==item[1])?.Portafolio || 0,
                  Benchmark:this.props.client_port_exposure.w_ac.find(k=>k.AssetClass==item[0] && k.Currency==item[1])?.Benchmark || 0,
                  'Portafolio Ajustado':this.props.client_port_exposure_trades.find(k=>k.AssetClass==item[0] && k.Currency==item[1])?.Portafolio || 0};
        }) : null;

        const risk_compar = this.props.client_port_metrics_trades!==null ? this.props.client_port_metrics_trades.map(item=>{
          return {'Métrica':item['Métrica'], 
                  Portafolio:this.props.client_port_metrics.rets_summ.filter(k=>k['Métrica']==item['Métrica'])[0]?.Portafolio,
                  benchmark:this.props.client_port_metrics.rets_summ.filter(k=>k['Métrica']==item['Métrica'])[0]?.Benchmark,
                  'Portafolio Ajustado':item.Portafolio};
        }) : null;

        const fund_options = this.props.user_wm.data.assets.filter(x=>x.AssetType=="Fund/ETF").sort(sort_by("Asset"))
                              .map(x=>{return({value:x.Asset, label:x.Asset})});

        return (
          <div className="container">
            {this.header()}
            <div className="row mt-4 justify-content-center">
              <div className='col' id="summ">
                <h6>Valor del portafolio: {/*toMoney(sum_array(this.props.client_portfolio.port.map(x=>x.mktValue)))*/}</h6>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className='col'>
                <h5>Insertar Operaciones ({this.props.client_portfolio.port[0]['ccy']})</h5>
              </div>
            </div>
            <Form onSubmit={this.addTrade}>
              <div className="row m-4 justify-content-center align-items-start">
                <div className='col-3'>
                  <Label>Seleccionar Activos</Label>
                  <CustomListSelect
                    className="basic-single"
                    options={fund_options}
                    value={{value:this.state.fund_sel, label:this.state.fund_sel}}
                    onChange={(e)=>this.setState({fund_sel:e.value})}
                    itemSize={60}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="seleccionar fondo..."
                  />
                </div>
                <div className='col-2'>
                  <FormGroup>
                    <Label for='mkt_value'>Valor de Mercado</Label>
                    <Input
                      id='mkt_value'
                      type='text'
                      onChange={this.handleNumericInput}
                      placeholder="valor de mercado..."
                    >
                    </Input>
                  </FormGroup>
                </div>
                <div className='col-2'>
                  <FormGroup>
                    <Label for='type'>Tipo</Label>
                    <Input
                      id='type'
                      type='select'
                      placeholder="seleccionar tipo..."
                    >
                      {[{label:'Compra', value:'BUY'}, {label:'Venta', value:'SELL'}].map((x,i)=>{
                        return <option key={i} value={x.value}>{x.label}</option>;
                      })}
                    </Input>
                  </FormGroup>
                </div>
              </div>
              <div className="row m-2 justify-content-center align-items-end">
                <div className='col-auto'>
                  <Button 
                    type='submit'
                    className='btn-corp'>
                    Agregar
                  </Button>
                </div>
                <div className='col-auto'>
                  <Button 
                    onClick={this.resetTrades}
                    className='btn-corp'>
                    Reset
                  </Button>
                </div>
                <div className='col-auto'>
                  <Button 
                    onClick={this.sendTrades}
                    className='btn-corp'>
                    Actualizar Métricas
                  </Button>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className="col-4 m-3">
                  <Alert
                    color='secondary'
                    isOpen={this.state.msg!=='' && this.state.msg!==null} 
                    toggle={()=>this.setState({msg:null})}>
                      {this.state.msg}
                  </Alert>
                </div>
              </div>
            </Form>
            {this.props.client_trades.length>0 ?
            <div className="row m-2 justify-content-center">
              <div className='col-auto'>
                <h6>Operaciones</h6>
                <RenderVirtualTable 
                  data={aggregate(this.props.client_trades.map(({assetName, mktValue, type})=>({assetName, mktValue, type})), ["assetName", "type"], ["mktValue"])} 
                  to_money={[false, false, true]}
                  cell_width={["250px", '150px', '150px']}
                  item_size={30}
                  style="black"
                  />
              </div>
            </div>
            : null
            }
            <div className="row m-3 justify-content-center">
              <div className='col-8'>
                <hr></hr>
              </div>
            </div>
            <div className="row m-2 justify-content-center align-items-center">
              <div className='col-2'>
                <FormGroup>
                  <Label>
                    <Input
                      id='perc'
                      type='checkbox'
                      onChange={()=>this.setState({show_perc:!this.state.show_perc})}
                    >
                    </Input>
                    {"    "}%
                  </Label>
                </FormGroup>
              </div>
            </div>
            <div className="row m-2 justify-content-center align-items-center">
              <div className='col-md-6'>
                <h6>Portafolio {port_saa.length>20 ? "(Top 20)": ""}</h6>
                <MultBarPlot 
                  data={port_saa.slice(0,20)}
                  nameKey='assetName'
                  vertical={true}
                  angle={0}
                  ytype="category" xtype="number"
                  colors={["#000000", "#2803fc"]}
                  xpercAxis={this.state.show_perc}
                  xmoneyAxis={!this.state.show_perc}
                  moneyTooltip={!this.state.show_perc}
                  percTooltip={this.state.show_perc}
                  width={500}
                  interval={0}
                  width={500}
                  height={400}
                  barsize={10}
                  legend={port_saa_adjust!==null ? true : false}
                  fontsize={12}
                />
              </div>
              <div className='col-md-6'>
                <h6>Desviación</h6>
                {port_dev ?
                  <MultBarPlot 
                    data={port_dev}
                    nameKey='assetName'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#2803fc"]}
                    xpercAxis={this.state.show_perc}
                    xmoneyAxis={!this.state.show_perc}
                    moneyTooltip={!this.state.show_perc}
                    percTooltip={this.state.show_perc}
                    width={500}
                    interval={0}
                    height={400}
                    barsize={20}
                    legend={false}
                    fontsize={12}
                  />
                : <p>No se han insertado operaciones.</p>
                }
              </div>
            </div>
            {this.props.client_port_metrics_trades!==null ?
            <>
              <div className="row m-5 justify-content-center">
                <div className='col-12'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-2 justify-content-center">
                <div className='col-6'>
                  <h6>Riesgo</h6>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={risk_compar} 
                        to_perc={[false, true, true, true]}
                        to_perc_row={[true, true, true, true, false, true, false, false, false]}
                        cell_width={['200px', "100px", '100px']}
                        item_size={30}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                <div className='col-6'>
                  <h6>Exposición</h6>
                  <MultBarPlot 
                    data={ac_compar}
                    nameKey='AssetClass'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#9ab5ff", "#2803fc"]}
                    xpercAxis={true}
                    percTooltip={true}
                    width={500}
                    ml={200}
                    interval={0}
                    height={400}
                    barsize={10}
                    legend={true}
                    fontsize={12}
                  />
      
                </div>
              </div>
            </>
            :null
            }

          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(ClientPortAdjust));